export default __webpack_public_path__ + "static/media/CapaMembers.892eb01c.svg";